import axios from 'axios';

const fetcher = async (url: string) => {
  const response = await axios.get(url);
  return response.data;
};

export async function getAccessToken() {
  const response = await axios.get(
    `https://graph.facebook.com/oauth/access_token?client_id=${process.env.NEXT_PUBLIC_FACEBOOK_APP_ID}&client_secret=${process.env.NEXT_PUBLIC_FACEBOOK_TOKEN}&grant_type=client_credentials`,
  );
  return response.data.access_token;
}

export async function getFacebookFeeds(pageId: string) {
  const accessToken = await getAccessToken();
  const response = await axios.get(
    `https://graph.facebook.com/v19.0/${pageId}/feed?access_token=${accessToken}`,
  );
  return response.data;
}
